import { ImgHTMLAttributes } from 'react'

import logoWhite from '@assets/logo-white.svg'
import logo from '@assets/logo.svg'
import { useTheme } from '@mui/material'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
	variant?: 'white' | 'color'
}

export default function Logo({ variant = 'color', ...rest }: Props) {
	const theme = useTheme()
	if (variant === 'white' || theme.palette.mode === 'dark')
		return <img src={logoWhite} alt="Artemis Logo" {...rest} />
	return <img src={logo} alt="Artemis Logo" {...rest} />
}
